module.exports = __webpack_public_path__ + "static/media/consultorioMedico.6c4642f8.svg";